import { all } from 'redux-saga/effects'
import { ruleRootSaga } from './rule'

export function* rootSaga() {
	yield all([ruleRootSaga()])
}
